
export const MATCH_HEIGHT = 520;
export const BOTTOM_TOY_HEIGHT = 620;
export const INVLIAD_NUM = 10000;

export const HALF_TOY_IMAGE = 45;
//export const GEN_TOY_HEIGHT = 1600;
export const TOY_SIZE = 90;

export const MOVE_SPEED_HORIZONTAL = 0.25;
export const MOVE_SPEED_VERTICAL = 0.35;

export const LAYER_HEIGHT = 268;
export const RELAX_DUR = 60;
//export const REVIVE_DUR = 1000;

export const GEN_WIDTH = 630;
export const GEN_HEIGHT = 380;

export const TOP_OFFSET = 180;
export const SIDE_OFFSET = 180;
export const SIDE_DROP_OFFSET = 120;
export const MATCHING_MOVE_STEP = 10;
export const UNLOCK_OFFSET = 60;

//export const VIEW_HEIGHT = 440;
export const VIEW_WIDTH = 360

export const gravity = 3;

export const LEVEL_TYPE_BOTTOM = 1;
export const LEVEL_TYPE_LEFT = 2;
export const LEVEL_TYPE_RIGHT = 3;
export const UNKOWN_TOY_PROTO = 0;

export const SPECIAL_TYPE_THUNDER = 1;
export const SPECIAL_TYPE_UNKNOWN_TOY = 2;
export const SPECIAL_TYPE_STOCK = 4;

export const STOCK_TAG_OFFSET = 35
export const STOCK_COUNT_DOWN = 3;

export const STOCK_RADIUS = 40;
export const STOCK_SQR_RADIUS = 1600;

export const MATCH_LEFT = 306 - 10;
export const MATCH_RIGHT = 306 + 120;

export const MOVE_COUNTDOWN = 1000;

export const CLICK_PROTECT_DUR = 220;
export const TOY_DOWN_TORQUE = 30;
export const TOY_DOWN_VELOCITY = 100;

export const MAX_RESET_COUNT = 4;
export const MAX_MATCH_COUNT = 4;
export const MAX_REVIVE_COUNT = 1;

export const MODE_COMMON = 0
export const MODE_COLLECT = 1
export const MODE_XMAS = 2

export const MODE_NAMES = ["cur_level", "collect_level", "Xmas_level"]


export const STOCK_POS: [number, number][] = [
    [200,       200],
    [720 - 200, 200],
    [360,       50],
    [200,       200],
    [720 - 200, 200],
]

export const BLOCK_SIZE = 90

export function getInitOffset():number {
    return Laya.stage.height - 900;
}
export function getStockPos(index : number):[number, number] {
    let ret = STOCK_POS[index];
    return [ret[0], ret[1] + getInitOffset()];
}

export function getViewHeight():number {
    return Laya.stage.height - BOTTOM_TOY_HEIGHT - TOP_OFFSET
}

export function shuffle<T>(array: T[]): T[] {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function playSound(sound: string) {
    Laya.SoundManager.playSound(sound);
}

export function playMusic(music: string) {
    Laya.SoundManager.playMusic(music);
}

export function setMusicVolume(vol: number) {
    Laya.SoundManager.setMusicVolume(vol);
}
export function setSoundVolume(vol: number) {
    Laya.SoundManager.setSoundVolume(vol);
}